<div class="loginwrapper">
  <div class="logoWrapper">
    <img class="logo" [src]="logoUrl">
  </div>
  <mat-card class="login-card">
    <mat-card-title>{{loginTitle}}</mat-card-title>
    <mat-card-content>
      <form [formGroup]="form">
        @if (!emailCodeInput) {
          <div>
            <p>
              <mat-form-field>
                <input type="text" matInput placeholder="Email" formControlName="username">
              </mat-form-field>
            </p>
            @if (!loginWithoutPassword) {
              <p>
                <mat-form-field>
                  <input [type]="hidePassword ? 'password' : 'text'" matInput placeholder="Password" formControlName="password">
                  <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                    <mat-icon class="hide-password-icon" [svgIcon]="hidePassword ? 'icon-eye-lock' : 'icon-eye'"></mat-icon>
                  </button>
                </mat-form-field>
              </p>
            }
          </div>
        }
        @if (emailCodeInput) {
          <div class="code-input-content">
            <p>We've sent a 6-digit code to your email. The code expires shortly, so please enter it soon.</p>
            <code-input appDistinctCode #codeInput
              [isCodeHidden]="false"
              [isNonDigitsCode]="false"
              [codeLength]="6"
              (distinctCodeCompleted)="onCodeCompleted($event)">
            </code-input>
            @if (loginWithoutPassword && emailCodeInput) {
              <div class="button resend-email-code-btn">
                <button mat-button (click)="sendEmail()" [disabled]="this.form.get('username')?.value === ''">
                  @if (!showResendEmailCodeTimerCounter) {
                    <span>Resend email code</span>
                  }
                  @if (showResendEmailCodeTimerCounter) {
                    <span class="resend-email-code-timer">
                      You can resend the email code in <strong>{{ resendEmailCodeTimerCounter }}</strong> seconds.
                    </span>
                  }
                </button>
              </div>
            }
          </div>
        }
        @if (error) {
          <p class="error">
            {{ error }}
          </p>
        }
        @if (!loginWithoutPassword) {
          <div class="button">
            <button type="submit" color="primary" mat-raised-button (click)="loginClicked()" [disabled]="isLoginSubmitting">
              @if (isLoginSubmitting) {
                <mat-spinner class="login-button-spinner" [diameter]="18"></mat-spinner>
              }
              <span>{{ isLoginSubmitting ? 'Logging In...' : 'Login' }}</span>
            </button>
          </div>
        }
        @if (loginWithoutPassword && !emailCodeInput) {
          <div class="button">
            <button mat-button (click)="sendEmail()" [disabled]="this.form.get('username')?.value === ''">Send email code</button>
          </div>
        }
      </form>
    </mat-card-content>
  </mat-card>
  <span class="login-w-passwd" (click)="loginWithoutPassword = !loginWithoutPassword; emailCodeInput = false">
    Login {{loginWithoutPassword ? 'with' : 'without'}} password
  </span>
  <div class="footer-copy">
    @if (isPayrollAdmin) {
      <span class="powered-by">Powered by Wallit</span>
    }
    <span class="version" [class.version-with-powered-by]="isPayrollAdmin">Version {{info}}</span>
  </div>
</div>
